import React from 'react'
import styled from 'styled-components'

const TagLocked = styled.div`
  height: 22px;
  font-size: 0.75rem;
  font-weight: 400;
  background: ${({ theme }) => theme.bg2};
  color: #4afc39;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  border-radius: 8px;

  display: flex;
  align-items: center;
  gap: 2px;

  svg {
    width: 14px;
  }
`
const TagUnlocked = styled.div`
  height: 22px;
  font-size: 0.75rem;
  font-weight: 400;
  background: #4afc39;
  color: #1e1e1e;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  border-radius: 8px;

  display: flex;
  align-items: center;
  gap: 2px;

  svg {
    width: 14px;
  }
`

interface TagI {
  variant: 1 | 2
  children: string | JSX.Element | JSX.Element[] | Element | Element[] | any
}

const Tag: React.FC<TagI> = ({ variant = 1, children }) => {
  return <>{variant === 1 ? <TagLocked>{children}</TagLocked> : <TagUnlocked>{children}</TagUnlocked>}</>
}
export default Tag
